/**
 * HUB-H — Carte entrée journal audit.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MagasinBadge from '../MagasinBadge';
import {
  SEVERITY_META,
  formatAuditDetails,
  formatEquipeDate,
  magasinFromLog,
} from '../../utils/equipe/equipeDisplay';

export default function ActiviteEquipeAuditCard({ log, testIdPrefix = 'activite-equipe' }) {
  const sev = SEVERITY_META[log.severity] || SEVERITY_META.info;
  const mag = magasinFromLog(log);

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-audit-${log.id}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <div className="min-w-0 flex-1">
          <Link
            to={`/admin/audit?action=${encodeURIComponent(log.action || '')}`}
            className="font-semibold text-[var(--rm-white)] hover:text-[var(--rm-red-light)] text-sm inline-flex items-center gap-1"
            data-testid={`${testIdPrefix}-audit-link-${log.id}`}
          >
            <span className="truncate">{log.action}</span>
            <ArrowRight className="w-3 h-3 shrink-0" />
          </Link>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            {log.entity_type}{log.entity_id ? ` · ${log.entity_id}` : ''}
          </p>
        </div>
        <span className={sev.badge}>{sev.label}</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-2">
        {mag && (mag === 'M1' || mag === 'M2') ? (
          <MagasinBadge code={mag} size="sm" />
        ) : mag ? (
          <span className="text-xs text-[var(--rm-gray-500)]">{mag}</span>
        ) : null}
        <span className="text-xs text-[var(--rm-gray-400)]">{log.username || '—'}</span>
        {log.role && <span className="text-xs text-[var(--rm-gray-500)]">({log.role})</span>}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
        <div>
          <span className="text-[var(--rm-gray-500)]">Date </span>
          <span className="text-[var(--rm-gray-300)]">{formatEquipeDate(log.created_at)}</span>
        </div>
        <div className="min-w-0">
          <span className="text-[var(--rm-gray-500)]">Détails </span>
          <span className="text-[var(--rm-gray-300)] truncate">{formatAuditDetails(log.details)}</span>
        </div>
      </div>
    </article>
  );
}
